<section class="section">
  <div class="section-video__inner container">
    <h2 class="section-video__title title-dark">EVRN control & consistency</h2>

    <app-comparison-slider
      beforeSrc="/assets/plans/experience-before-video.mp4"
      afterSrc="/assets/plans/experience-after-video.mp4"
      beforeLabel="EVRN video layout reference"
      afterLabel="1:1 generative render"
    />
  </div>
</section>
